import React from "react";
import styles from "./Education.module.css";
import Carousel from "react-elastic-carousel";
import Fade from "react-reveal/Fade";
import Typewriter from "typewriter-effect";
import college from "../../Assets/Education/college.png";
import highschool from "../../Assets/Education/highschool.png";
import school from "../../Assets/Education/school.png";

const Education = () => {
  const breakpoints = [
    { width: 1, itemsToShow: 1 },
    { width: 500, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
  ];
  return (
    <div className={styles.educationMainDiv}>
      <h1 style={{ padding: "0 10% 0 10%" }}>
        <Typewriter
          style={{ fontWeight: "bold" }}
          options={{
            autoStart: true,
            loop: true,
            delay: 40,
            strings: ["Education()"],
          }}
        />
      </h1>
      <div>
        <div className={styles.educationDiv}>
          <Carousel breakPoints={breakpoints}>
            <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<College/>"}</i>
                </h5>
                <img alt="poster" src={college} />
                <h2 style={{ fontSize: "20px" }}>
                  Viva Institute of Technology(Mumbai University)
                </h2>
                <p style={{ marginTop: "10px", fontSize: "15px" }}>
                  Pursuing B.E in Electronics & Telecommunication
                  Engineering(Currently in 8th Semester)
                </p>
                <p style={{ marginTop: "10px", fontSize: "17px" }}>
                  Aug 2019 - Present
                </p>
                <p style={{ marginTop: "10px", fontSize: "17px" }}>
                  C.G.P.A - 8.5
                </p>
              </div>
            </Fade>
            <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<High School/>"}</i>
                </h5>
                <img alt="poster" src={highschool} />
                <h2 style={{ fontSize: "20px" }}>
                  S.S & L.S Patkar College of Arts & Science, Mumbai
                </h2>
                <p style={{ marginTop: "10px", fontSize: "15px" }}>
                  Completed Class 12th - Higher Secondary Certificate(HSC)
                </p>
                <p style={{ marginTop: "10px", fontSize: "17px" }}>
                  Aug 2017 - March 2019
                </p>
                <p style={{ marginTop: "10px", fontSize: "17px" }}>
                  Percentage - 72.00%
                </p>
              </div>
            </Fade>
            <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<School/>"}</i>
                </h5>
                <img alt="poster" src={school} />
                <h2 style={{ fontSize: "20px" }}>
                  Bangur Vidya Bhawan School & Junior College, Mumbai
                </h2>
                <p style={{ marginTop: "10px", fontSize: "15px" }}>
                  Completed Class 10th - Secondary School Certificate(SSC)
                </p>
                <p style={{ marginTop: "10px", fontSize: "17px" }}>
                  July 2008 - March 2017
                </p>
                <p style={{ marginTop: "10px", fontSize: "17px" }}>
                  Percentage - 84.40%
                </p>
              </div>
            </Fade>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Education;
